import { render, staticRenderFns } from "./buy-credits-cta.vue?vue&type=template&id=5990039e&scoped=true&"
import script from "./buy-credits-cta.vue?vue&type=script&lang=ts&"
export * from "./buy-credits-cta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990039e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
